import Hotel from './Hotel'

export default Hotel



// WEBPACK FOOTER //
// ./src/features/Hotel/components/Hotel/index.js